import { useEffect, useReducer, useState } from "react";
import AppRoutes from "./routes/AppRoutes";
import { AuthContext, AuthReducer, initialState } from "./contexts/Auth/Auth.Context";
import { REACT_APP_SESSION_DATA } from "./constants";
import axios from "./utils/axios";
import { ThemeProvider, useTheme } from "./components/theme-provider";
import { Center, ColorScheme, ColorSchemeProvider, createEmotionCache, Loader, MantineProvider } from '@mantine/core';
import { useLocalStorage } from "@mantine/hooks";
import { Toaster } from "./components/ui/toaster";

function App() {
  const [state, dispatch] = useReducer(AuthReducer, initialState);

  const [userSession, ] = useState(localStorage.getItem(REACT_APP_SESSION_DATA));

  useEffect(() => {
    const bootstrapAsync = async () => {
      let userToken;
      let data;

      console.log(userSession);

      try{
        userToken = userSession;

        if(userToken){
          const {
            data: {
              data: accountData,
              token: accessToken
            }
          } = await axios.get("/users/login-with-token", {
            headers: {
              'Authorization': `Bearer ${userToken}`,
              'Content-Type': 'application/json',
            }
          });

          userToken = accessToken;
          data = accountData;
        }
      } catch(error){
        console.log(error);
        userToken = null;
        data = null;
      }

      dispatch({type: "RESTORE_TOKEN", token: userToken, data: data });
    }

    bootstrapAsync();

  }, [userSession]);

  const LoaderPage = () => {
      return (
        <Center my={"20%"}>
          <Loader variant="bars" color="green" size="lg" />
    </Center>
      )
  }

  const [colorScheme, setColorScheme] = useLocalStorage<ColorScheme>({
    key: 'color-scheme',
    defaultValue: 'light', // 'light' or 'dark'
    getInitialValueInEffect: true,
  });

  const [dir] = useState("ltr");

  const toggleColorScheme = (value?:ColorScheme) => {
    const nextColorScheme = value || (colorScheme === 'dark' ? 'light' : 'dark');
    setColorScheme(nextColorScheme);
  };

  const myCache = createEmotionCache({ key: "wits-platform"});

  return (
    <ColorSchemeProvider colorScheme={colorScheme} toggleColorScheme={toggleColorScheme}>
    <MantineProvider
    withGlobalStyles
    withNormalizeCSS
    theme={{
      colorScheme,
      primaryColor: "green",
      primaryShade: 9,
      cursorType: "pointer", 
    }}
    emotionCache={myCache}
  >
    <ThemeProvider defaultTheme={useTheme().theme} storageKey="vite-ui-theme">
      <AuthContext.Provider value={{ state, dispatch}}>
        {state.isLoading ? (
          <LoaderPage />
        ) : (
          <AppRoutes />
        )}
        <Toaster />
      </AuthContext.Provider>
    </ThemeProvider>
    </MantineProvider>
    </ColorSchemeProvider>
  );
}

export default App;
